export const LOADING_STATE = 'LOADING_STATE';


// WEBPACK FOOTER //
// ./src/store/mutation-types.js